/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";

class Subcategory extends Component {
  state = {
    data: {
      nameEn: "",
      nameAr: "",
      nameKu: "",
      serviceFee: "",
      categoryId: "",
    },

    allCategory: [],

    contentHeader: "Subcategories",
    addButtonLabel: "Add Subcategory",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetSubcategories",
    singleItemUrl: "/api/data/GetSubcategory",
    addUrl: "/api/data/AddSubcategory",
    editUrl: "/api/data/EditSubcategory",
    deleteUrl: "/api/data/DeleteSubcategory",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add Subcategory",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit Subcategory",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    tableData: [],
  };

  componentDidMount() {
    this.getData();
    this.getAllCategory();
  }

  getAllCategory() {
    post("/api/data/getallcategories", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          allCategory: apiResponse.data.respData.data,
        });
      }
    );
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
      allClaims: [],
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["nameEn"] = apiResponse.data.respData.data[0].NAME_EN;
      data["nameAr"] = apiResponse.data.respData.data[0].NAME_AR;
      data["nameKu"] = apiResponse.data.respData.data[0].NAME_KU;
      data["serviceFee"] = apiResponse.data.respData.data[0].SERVICE_FEE;
      data["categoryId"] = apiResponse.data.respData.data[0].CATEGORY_ID;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: this.props.t("dialog.deleteTitle"),
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }
    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.subcategoryEn"),
        field: "NAME_EN",
      },
      {
        id: 2,
        label: t("col.subcategoryAr"),
        field: "NAME_AR",
      },
      {
        id: 3,
        label: t("col.subcategoryKu"),
        field: "NAME_KU",
      },
      {
        id: 4,
        label: t("col.mainCategory"),
        field: "MAIN_CATEGORY",
      },
      {
        id: 5,
        label: t("col.serviceFee"),
        field: "SERVICE_FEE",
      },
      {
        id: 6,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 7,
        label: t("col.lastUpdate"),
        field: "LAST_UPDATE",
      },
      {
        id: 8,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB18"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB19"]) && (
                <div className="inner" title="Delete">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.subcategory")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB17"]) && (
              <Button
                label={t("pages.addSubcategory")}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "dropdown",
                id: "categoryId",
                label: t("col.mainCategory"),
                options: this.state.allCategory,
                disabled: false,
              },
              {
                type: "text",
                id: "nameEn",
                label: t("col.subcategoryEn"),
                disabled: false,
              },

              {
                type: "text",
                id: "nameKu",
                label: t("col.subcategoryKu"),
                disabled: false,
              },

              {
                type: "text",
                id: "serviceFee",
                label: t("col.serviceFee"),
                disabled: false,
              },
              {
                type: "text",
                id: "nameAr",
                label: t("col.subcategoryAr"),
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(Subcategory);
